import React, { useState, useEffect, useRef, useCallback } from 'react';
import { Link, useHistory } from 'react-router-dom';
import {
    Toolbar,
    Paper,
    Button,
    Grid,
    Typography,
    Checkbox,
    TableContainer,
    Table,
    TableHead,
    TableCell,
    TableRow,
    TableBody,
    TablePagination,
    Switch,
    FormControlLabel,
} from '@material-ui/core';
import SaveIcon from '@material-ui/icons/Save';
import PhotoCameraIcon from '@material-ui/icons/PhotoCamera';
import DeleteIcon from '@material-ui/icons/Delete';
import MaskedInput from 'react-text-mask';
import UploadIcon from '@mui/icons-material/Upload';
import VideocamIcon from '@mui/icons-material/Videocam';
import { Formik } from 'formik';
import Webcam from 'react-webcam';
import { makeStyles } from '@material-ui/core/styles';
import { grey } from '@material-ui/core/colors';
import SearchIcon from '@material-ui/icons/Search';
import HelpIcon from '@material-ui/icons/HelpOutlineOutlined';
import { loadPlayer } from 'rtsp-relay/browser';

import SideMenu from '../../components/SideMenu';
import Alert from '../../components/Alert';
import Input from '../../components/Input';
import Select from '../../components/Select';
import DatePicker from '../../components/DatePicker';
import Popup from '../../components/Popup';
import Autocomplete from '../../components/Autocomplete';
import SchedulePicker from '../../components/SchedulePicker';
import AccessPicker from '../../components/AccessPicker';
import CredentialsManager from '../../components/CredentialsManager';
import RedirectToUser from '../../components/RedirectToUser';
import FullScreenDialog from '../../components/FullScreenDialog';
import IPWebcamPicker from '../../components/IPWebcamPicker';
import { ListPageHeading } from '../../components/ListPageLayout';

import config from '../../configs/config';
import api from '../../services/api';
import {usePlaces} from "../../hooks";

export default function UserCreate() {
    const classes = useStyles();

    const history = useHistory();

    const scheduleRef = useRef();
    const credentialsRef = useRef()

    const accessRef = useRef(null);

    const [fullAccess, setFullAccess] = useState(false)

    let initialValues = {
        name: '',
        birthday: null,
        sex: 'unknown',
        doc_type: '',
        doc_number: '',
        issuing_agency: '',
        email: '',
        phone: null,
        occupation: '',
        role: 'employee',
        face_image: null,
        login: '',
        password: '',
        custom_inputs: [],
        antipassback: false,
        active_register: true,
        visiting_location: null,
        notes: '',
        only_allowed_by_related_access: false,
    };

    const [openGoBack, setOpenGoBack] = useState(false);

    const [placesSearch, setPlacesSearch] = useState("");
    const [selectedPlace, setSelectedPlace] = useState({});
    const places = usePlaces({
        search: placesSearch,
    });

    const [cameraOpened, setCameraOpened] = useState(false);
    const [message, setMessage] = useState({
        open: false,
        variant: '',
        text: '',
    });

    const [relatedSearch, setRelatedSearch] = useState('');
    const [relatedLimit, setRelatedLimit] = useState(10);
    const [relatedPage, setRelatedPage] = useState(0);
    const [relatedTotal, setRelatedTotal] = useState(0);
    const [relatedResult, setRelatedResult] = useState([]);
    const [fetchOnlySelectedRelated, setFetchOnlySelectedRelated] = useState(false);

    const [dependantSearch, setDependantSearch] = useState('');
    const [dependantLimit, setDependantLimit] = useState(10);
    const [dependantPage, setDependantPage] = useState(0);
    const [dependantTotal, setDependantTotal] = useState(0);
    const [dependantResult, setDependantResult] = useState([]);
    const [fetchOnlySelectedDependant, setFetchOnlySelectedDependant] = useState(false);

    const [relatedRelationships, setRelatedRelationships] = useState([]);
    const [dependantRelationships, setDependantRelationships] = useState([]);
    const [openRelatedModal, setOpenRelatedModal] = useState(false);
    const [openDependantModal, setOpenDependantModal] = useState(false);

    const [openRTSP, setOpenRTSP] = useState(false);
    const [rtspRunning, setRTSPRunning] = useState(false);
    const [loadingRSTP, setLoadingRSTP] = useState(false);

    const [selectedWebcam, setSelectedWebcam] = useState(null);
    const [webcamPickerOpen, setWebcamPickerOpen] = useState(false);

    const rtspCanvas = useRef(null);

    const handleOnlySelectedRelated = (checked) => {
        setRelatedPage(0);
        setFetchOnlySelectedRelated(checked);
    };

    const handleOnlySelectedDependant = (checked) => {
        setDependantPage(0);
        setFetchOnlySelectedDependant(checked);
    }

    const [profiles, setProfiles] = useState([]);
    const [profilesSearch, setProfilesSearch] = useState("");
    const [profilesPage, setProfilesPage] = useState(0);
    const [profilesLimit, setProfilesLimit] = useState(10);
    const [profilesTotal, setProfilesTotal] = useState(0);
    const [fetchOnlySelectedProfiles, setFetchOnlySelectedProfiles] = useState(false);
    const [selectedProfiles, setSelectedProfiles] = useState([]);
    const [openProfilesModal, setOpenProfilesModal] = useState(false);

    const handleOnlySelectedProfiles = (checked) => {
        setProfilesPage(0);
        setFetchOnlySelectedProfiles(checked);
    };

    const toggleProfilesModal = () => setOpenProfilesModal((curr) => !curr);

    useEffect(() => {
        const loadUsers = async () => {
            try {
                const result = await api.get('/user/list_by_relationship', {
                    params: {
                        search: relatedSearch,
                        limit: relatedLimit,
                        page: relatedPage,
                        onlySelected: fetchOnlySelectedRelated,
                        selectedPeople: relatedRelationships,
                    },
                });

                const { count, users } = result.data;

                console.log({ users })

                setRelatedResult(users);
                setRelatedTotal(count);
            }
            catch (err) {
                console.log(err);
            }
        };

        loadUsers();

        //eslint-disable-next-line
    }, [relatedPage, relatedLimit, relatedSearch, fetchOnlySelectedRelated]);

    useEffect(() => {
        const loadUsers = async () => {
            try {
                const result = await api.get('/user/list_by_relationship', {
                    params: {
                        search: dependantSearch,
                        limit: dependantLimit,
                        page: dependantPage,
                        onlySelected: fetchOnlySelectedDependant,
                        selectedPeople: dependantRelationships,
                    },
                });

                const { count, users } = result.data;

                console.log({ users })

                setDependantResult(users);
                setDependantTotal(count);
            }
            catch (err) {
                console.log(err);
            }
        };

        loadUsers();

        //eslint-disable-next-line
    }, [dependantPage, dependantLimit, dependantSearch, fetchOnlySelectedDependant]);

    useEffect(() => {
        const loadProfiles = async () => {
            try {
                const result = await api.get('/profile/index_to_bind', {
                    params: {
                        search: profilesSearch,
                        limit: profilesLimit,
                        page: profilesPage,
                        only_selected: fetchOnlySelectedProfiles,
                        selected_profiles: selectedProfiles,
                    },
                });

                const { count, profiles } = result.data;

                setProfiles(profiles);
                setProfilesTotal(count);
            } catch (err) {
                console.log(err);
            }
        };

        loadProfiles();
    }, [profilesSearch, profilesLimit, profilesPage, selectedProfiles, fetchOnlySelectedProfiles]);

    useEffect(() => {
        if (openRTSP && selectedWebcam) {
            const {host, username, password} = selectedWebcam;

            setTimeout(() => {
                loadPlayer({
                    url: `${config.relayUrl}/api/stream/?nvr=${host}&cam=1&username=${username}&password=${password}&subtype=0`,
                    canvas: rtspCanvas.current,
                    onSourceEstablished: connectionEstabilished,
                    onPlay: playStarted,
                    onDisconnect: () => setRTSPRunning(false),
                });
            }, 2000);
        }
    }, [openRTSP, selectedWebcam]);

    useEffect(() => {
        if (selectedWebcam) {
            setOpenRTSP(true);
        }
        else {
            handleCloseRSTP();
        }
    }, [selectedWebcam]);

    const connectionEstabilished = () => {
        setLoadingRSTP(true);
    };

    const playStarted = () => {
        setRTSPRunning(true);
        setLoadingRSTP(false);
    }

    const handleCloseRSTP = () => {
        setOpenRTSP(false);
        setLoadingRSTP(false);
        setRTSPRunning(false);
        setWebcamPickerOpen(false);
    }

    const changePage = (_, newPage, type) => {
        if (type === 'related') {
            setRelatedPage(newPage);
        } else if (type === 'dependant') {
            setDependantPage(newPage);
        } else if (type === 'profile') {
            setProfilesPage(newPage);
        }
    }

    const quantityPerPage = (target, type) => {
        if (type === 'related') {
            setRelatedLimit(parseInt(target.value, 10));
            setRelatedPage(0);
        } else if (type === 'dependant') {
            setDependantLimit(parseInt(target.value, 10));
            setDependantPage(0);
        } else if (type === 'profile') {
            setProfilesLimit(parseInt(target.value, 10));
            setProfilesPage(0);
        }
    };

    const checkRelated = (type, isSelected, id) => {
        if (type === "single") {
            let newRelated = Object.assign([], relatedRelationships);
            if (isSelected) {
                newRelated.push(id);
            } else {
                let index = relatedRelationships.indexOf(id);
                newRelated.splice(index, 1);
            }
            setRelatedRelationships(newRelated);
        } else if (type === 'all') {
            let allUsers = [];
            if (isSelected) {
                allUsers = Object.assign([], relatedRelationships);
                relatedResult.forEach(user => {
                    if (!allUsers.includes(user.id)) {
                        allUsers.push(user.id)
                    }
                });
            } else {
                let userIds = relatedResult.map(el => el.id);
                allUsers = relatedRelationships.filter(user => !userIds.includes(user));
            }
            setRelatedRelationships(allUsers);
        }
    };

    const checkDependant = (type, isSelected, id) => {
        if (type === "single") {
            let newDependant = Object.assign([], dependantRelationships);
            if (isSelected) {
                newDependant.push(id);
            } else {
                let index = dependantRelationships.indexOf(id);
                newDependant.splice(index, 1);
            }
            setDependantRelationships(newDependant);
        } else if (type === 'all') {
            let allUsers = [];
            if (isSelected) {
                allUsers = Object.assign([], dependantRelationships);
                dependantResult.forEach(user => {
                    if (!allUsers.includes(user.id)) {
                        allUsers.push(user.id)
                    }
                });
            } else {
                let userIds = dependantResult.map(el => el.id);
                allUsers = dependantRelationships.filter(user => !userIds.includes(user));
            }
            setDependantRelationships(allUsers);
        }
    };

    const checkProfile = (type, isSelected, id) => {
        if (type === "single") {
            let newProfiles = Object.assign([], selectedProfiles);
            if (isSelected) {
                newProfiles.push(id);
            } else {
                let index = selectedProfiles.indexOf(id);
                newProfiles.splice(index, 1);
            }
            setSelectedProfiles(newProfiles);
        } else if (type === 'all') {
            let allProfiles = [];
            if (isSelected) {
                allProfiles = Object.assign([], selectedProfiles);
                profiles.forEach(user => {
                    if (!allProfiles.includes(user.id)) {
                        allProfiles.push(user.id)
                    }
                });
            } else {
                let profileIds = profiles.map(el => el.id);
                allProfiles = selectedProfiles.filter(profile => !profileIds.includes(profile));
            }
            setSelectedProfiles(allProfiles);
        }
    };

    const [enabledToLogin, setEnabledToLogin] = useState(false);

    const webcamRef = useRef(null);

    const [customInputs, setCustomInputs] = useState([]);

    useEffect(() => {
        const findInputs = async () => {
            try {
                const result = await api.get('/custom_input/list', {
                    params: {
                        target: ['all', 'regular'],
                        page: 0,
                        limit: 30,
                    }
                });

                const { custom_inputs } = result.data;

                setCustomInputs(custom_inputs);
            }
            catch (err) {
                console.log(err);
            }
        };

        findInputs();
    }, []);


    const [personTypes, setPersonTypes] = useState([]);
    const [personType, setPersonType] = useState({});
    const [personTypeSearch, setPersonTypeSearch] = useState("");

    useEffect(() => {
        const findTypes = async () => {
            try {
                const result = await api.get('/person_type/list', {
                    params: {
                        show_exceptions: false,
                        limit: 30,
                        search: personTypeSearch,
                    }
                });

                const { personTypes } = result.data;

                setPersonTypes(personTypes);
            } catch (err) {
                console.log(err)
            }
        }

        findTypes();
    }, [personTypeSearch]);

    const [orgsSelect, setOrgsSelect] = useState([]);
    const [orgSearch, setOrgSearch] = useState("");
    const [selectedOrg, setSelectedOrg] = useState({});

    useEffect(() => {
        const findOrg = async () => {
            try {
                const result = await api.get('/organizational_structure/index', {
                    params: {
                        search: orgSearch,
                    }
                });

                const { orgs } = result.data;

                setOrgsSelect(orgs);
            }
            catch (err) {
                console.log(err.message);
            }
        };

        findOrg();
    }, [orgSearch]);

    const [loadedImage, setLoadedImage] = useState(null);

    const takeWebcamSnapshot = async setFieldValue => {
        if (!selectedWebcam) return;

        try {
            const result = await api.get(`/device/take_snapshot/${selectedWebcam.id}`, {
                responseType: 'blob',
            });

            const dataUrl = URL.createObjectURL(result.data);

            const image = await fetch(dataUrl)
                .then(res => res.arrayBuffer())
                .then(buffer => new File([buffer], 'face_image.jpeg', {type: 'image/jpeg'}));

            setFieldValue('face_image', image);
            setSelectedWebcam(null);
            handleCloseRSTP();
        }
        catch (err) {
            console.log(err);
        }
    };

    const captureImage = useCallback(async setFieldValue => {
        const dataUrl = webcamRef.current.getScreenshot();

        if (dataUrl) {
            const mimeType = dataUrl.match(/[^:]\w+\/[\w-+\d.]+(?=;|,)/);

            const image = await fetch(dataUrl)
                .then(res => res.arrayBuffer())
                .then(buffer => new File([buffer], 'face_image.jpeg', { type: mimeType[0] }));

            setFieldValue('face_image', image);
        }
    }, [webcamRef]);

    const uploadImage = (e, setFieldValue) => {
        const reader = new FileReader()
        reader.onload = () => {
            if (reader.readyState === 2) {
                setFieldValue('face_image', e.target.files[0]);
                // console.log('uploaded face image')
            }
        }
        reader.readAsDataURL(e.target.files[0]);
    }

    const ImagePreview = ({ image }) => {
        if (loadedImage === null) {
            const reader = new FileReader();
            reader.onload = () => {
                if (reader.readyState === 2) {
                    setLoadedImage(reader.result)
                }
            }
            reader.readAsDataURL(image);
            // console.log('image converted')
        }
        // console.log('rendering preview');

        return (
            <img
                src={loadedImage}
                alt="Imagem de identificação"
                style={{ maxWidth: '100%', maxHeight: "100%" }}
            />
        );
    };

    const saveUser = async (values, formik) => {
        try {
            const data = new FormData();

            data.append('face_image', values.face_image);

            if (!values.org_id) values.org_id = undefined;

            values.visiting_location = selectedPlace.id;

            const userData = {
                ...values,
                schedule,
                person_type_id: personType.id,
                org_id: selectedOrg.id,
                related_relationships: relatedRelationships,
                dependant_relationships: dependantRelationships,
                credentials: credentialsRef.current.getValues(),
                profiles: selectedProfiles,
                ...accessRef.current.getValues(),
            };

            console.log({ userData });

            userData.face_image = undefined;

            data.append('user_data', JSON.stringify(userData));
            // console.log("user data :|", userData)
            const result = await api.post('/user/create', data, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });

            const { user } = result.data;

            scheduleRef.current.resetValues();
            accessRef.current.resetValues();
            credentialsRef.current.resetValues();
            setFullAccess(false);
            setPersonType({});
            setSelectedOrg({});
            formik.setSubmitting(false);
            resetForm(formik);

            setRelatedSearch('');
            setRelatedLimit(10);
            setRelatedPage(0);
            setFetchOnlySelectedRelated(false);
            setRelatedRelationships([]);

            setDependantSearch('');
            setDependantLimit(10);
            setDependantPage(0);
            setFetchOnlySelectedDependant(false);
            setDependantRelationships([]);

            setProfilesSearch("");
            setProfilesLimit(10);
            setProfilesPage(0);
            setFetchOnlySelectedProfiles(false);
            setSelectedProfiles([]);
            setSelectedPlace({});


            setMessage({
                open: true,
                variant: 'success',
                text: `Pessoa ${user.name} cadastrada com sucesso!`,
            });

            setTimeout(() => setOpenGoBack(true), 1500);
        }
        catch (err) {
            setMessage({
                open: true,
                variant: 'error',
                text: err.error,
            });
        }
    };

    const formatUserData = values => {
        if (values.phone)
            values.phone = values.phone.replace(/\D/g, '');
    };

    const resetForm = formik => {
        formik.resetForm();
    };

    const closeMessage = () => {
        setMessage({
            open: false,
            variant: '',
            text: '',
        });
    };

    const [schedule, setSchedule] = useState(null);



    return (
        <div className={classes.root}>
            <SideMenu />
            <main className={classes.content}>
                <Toolbar />
                <Grid container spacing={3} className={classes.pageGrid}>
                    <Grid item xs={12}>
                        <div className={classes.pageHeader}>
                            <div>
                                <ListPageHeading icon="person" title="Cadastrar pessoa" />
                                <Typography className={classes.pageSubtitle}>
                                    Preencha os dados de identificação, acesso e autorização da nova pessoa.
                                </Typography>
                            </div>
                            <Link className={classes.helpLink} to='/ajuda/cadastrar-pessoa'>
                                <HelpIcon />
                                <span>Ajuda</span>
                            </Link>
                        </div>
                    </Grid>
                    <Formik
                        initialValues={initialValues}
                        validate={formatUserData}
                        onSubmit={saveUser}
                    >
                        {({ values, setFieldValue, handleChange, handleSubmit, isSubmitting }) => (
                            <>
                                <Grid item xs={12}>
                                    <Paper elevation={0} className={classes.paper}>
                                        <form id="user-create" onSubmit={handleSubmit} className={classes.form}>
                                            <div className={classes.formHeader}>
                                                <Typography className={classes.formHeaderTitle}>
                                                    Informações da pessoa
                                                </Typography>
                                                <Typography className={classes.formHeaderSubtitle}>
                                                    Os campos obrigatórios devem ser preenchidos antes de salvar o cadastro.
                                                </Typography>
                                            </div>
                                            <div className={classes.formBody}>
                                            <Grid container spacing={3}>
                                                <Grid item xs={12} md={4} lg={3} className={classes.photoSection}>
                                                    <div className={classes.faceImageContainer}
                                                        style={{
                                                            height: '300px',
                                                            width: '100%',
                                                        }}
                                                    >
                                                        <div
                                                            className={classes.faceImageContent}
                                                            style={{
                                                                width: "100%",
                                                                height: openRTSP ? "600px" : "200px"
                                                            }}
                                                        >
                                                            {!!openRTSP ? (
                                                                <div style={{
                                                                    backgroundmaxHeight: '100%',
                                                                    height: '100%',
                                                                    maxWidth: '100%',
                                                                    margin: 'auto',
                                                                    display: 'flex',
                                                                    justifyContent: 'center',
                                                                }}>
                                                                    <canvas ref={rtspCanvas} style={{ width: '100%', height: '100%', borderRadius: '8px', objectFit: 'contain' }}></canvas>
                                                                </div>
                                                            ) : !cameraOpened ? (
                                                                values.face_image ? (
                                                                    <ImagePreview image={values.face_image} />
                                                                ) : (
                                                                    <div className={classes.noImage}>
                                                                        <PhotoCameraIcon />
                                                                        <Typography variant="subtitle2">
                                                                            SEM IMAGEM
                                                                        </Typography>
                                                                    </div>
                                                                )
                                                            ) : (
                                                                <Webcam
                                                                    ref={webcamRef}
                                                                    audio={false}
                                                                    screenshotFormat="image/jpeg"
                                                                    screenshotQuality={1}
                                                                    forceScreenshotSourceSize={true}
                                                                    // width="100%"
                                                                    height="100%"
                                                                />
                                                            )}
                                                        </div>
                                                        {values.face_image && (
                                                            <Button
                                                                className={classes.removeImageButton}
                                                                size="small"
                                                                type="button"
                                                                variant="outlined"
                                                                color="secondary"
                                                                endIcon={<DeleteIcon />}
                                                                fullWidth
                                                                onClick={() => {
                                                                    setFieldValue('face_image', null);
                                                                    setLoadedImage(null);
                                                                }}
                                                            >
                                                                Remover
                                                            </Button>
                                                        )}
                                                        {
                                                            !values.face_image && (
                                                                <>
                                                                    <Button
                                                                        className={cameraOpened ? classes.faceImageButton : classes.faceImageButtonDefault}
                                                                        type="button"
                                                                        variant="outlined"
                                                                        color="primary"
                                                                        endIcon={<PhotoCameraIcon />}
                                                                        fullWidth
                                                                        onClick={async () => {
                                                                            if (cameraOpened) await captureImage(setFieldValue);

                                                                            setCameraOpened(!cameraOpened);
                                                                        }}
                                                                    >
                                                                        {cameraOpened ? 'Tirar foto' : 'Abrir câmera'}
                                                                    </Button>
                                                                    {
                                                                        !cameraOpened && (
                                                                            <>
                                                                                <Button
                                                                                    className={classes.faceImageButtonDefault}
                                                                                    variant="outlined"
                                                                                    type="button"
                                                                                    color="primary"
                                                                                    fullWidth={true}
                                                                                    onClick={() => setWebcamPickerOpen(true)}
                                                                                    endIcon={<VideocamIcon />}
                                                                                >
                                                                                    Selecionar Webcam
                                                                                </Button>
                                                                                <Button
                                                                                    className={classes.faceImageButton}
                                                                                    type="button"
                                                                                    variant="outlined"
                                                                                    color="primary"
                                                                                    endIcon={<UploadIcon />}
                                                                                    fullWidth
                                                                                    component="label"
                                                                                >
                                                                                    Adicionar Foto
                                                                                    <input
                                                                                        name='map_image'
                                                                                        type="file"
                                                                                        accept="image/*"
                                                                                        onChange={(e) => uploadImage(e, setFieldValue)}
                                                                                        hidden
                                                                                        required={false}
                                                                                    />
                                                                                </Button>
                                                                            </>
                                                                        )
                                                                    }
                                                                </>
                                                            )
                                                        }
                                                    </div>
                                                </Grid>
                                                <Grid item xs={12} md={8} lg={9}>
                                                    <Grid item xs={12} className={classes.formSection}>
                                                        <Typography variant="subtitle1" className={classes.formSectionTitle}>
                                                            DADOS PESSOAIS
                                                        </Typography>
                                                        <Grid container spacing={3}>
                                                            <Grid item xs={12} md={8}>
                                                                <Input
                                                                    label="Nome completo"
                                                                    textFieldProps={{
                                                                        name: 'name',
                                                                        placeholder: 'Nome completo',
                                                                        onChange: (e) => {
                                                                            const letras = e.target.value.replace(/[^A-Za-zÀ-ÖØ-öø-ÿ\s]/g, '');
                                                                            setFieldValue('name', letras);
                                                                        },
                                                                        value: values.name,
                                                                        fullWidth: true,
                                                                        required: true,
                                                                    }}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={4}>
                                                                <Autocomplete
                                                                    label="Tipo de Pessoa"
                                                                    placeholder="Tipo de pessoa"
                                                                    id="type_of_person"
                                                                    options={personTypes}
                                                                    getOptionLabel={({ name }) => name || ''}
                                                                    onChange={(_, value) => setPersonType(value)}
                                                                    getOptionSelected={(option, value) => (option.id === value.id)}
                                                                    onInputChange={(_, value) => setPersonTypeSearch(value)}
                                                                    value={personType}
                                                                    required={true}
                                                                    fullWidth />
                                                            </Grid>
                                                        </Grid>
                                                        <Grid container spacing={3}>
                                                            <Grid item xs={12} sm={6} md={3}>
                                                                <Input
                                                                    label="Orgão Emissor"
                                                                    textFieldProps={{
                                                                        name: 'issuing_agency',
                                                                        placeholder: 'Orgão Emissor',
                                                                        onChange: handleChange,
                                                                        value: values.issuing_agency,
                                                                        fullWidth: true,
                                                                    }}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} sm={6} md={3}>
                                                                <Select
                                                                    label="Tipo de Documento"
                                                                    options={[
                                                                        { label: '-- Selecione --', value: '' },
                                                                        { label: 'CPF', value: 'unknown' },
                                                                        { label: 'RG', value: 'ic' },
                                                                        { label: 'Passaporte', value: 'passport' },
                                                                        { label: 'Outro', value: 'other' },
                                                                    ]}
                                                                    textFieldProps={{
                                                                        name: 'doc_type',
                                                                        onChange: handleChange,
                                                                        fullWidth: true,
                                                                        value: values.doc_type,
                                                                        required: values.doc_number !== null && values.doc_number !== '',
                                                                    }}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} sm={6} md={3}>
                                                                <Input
                                                                    label="Número do Documento"
                                                                    textFieldProps={{
                                                                        name: 'doc_number',
                                                                        placeholder: 'Número do Documento',
                                                                        onChange: handleChange,
                                                                        value: values.doc_number,
                                                                        fullWidth: true,
                                                                        required: values.doc_type !== null && values.doc_type !== '',
                                                                    }}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} sm={6} md={3}>
                                                                <DatePicker
                                                                    label="Data de nascimento"
                                                                    format="DD/MM/YYYY"
                                                                    id="date"
                                                                    value={values.birthday}
                                                                    placeholder="Data de nascimento"
                                                                    onChange={date => setFieldValue('birthday', date && date.format())}
                                                                    cancelLabel="cancelar"
                                                                    fullWidth={true}
                                                                />
                                                            </Grid>

                                                        </Grid>

                                                        <Grid container spacing={3}>
                                                            <Grid item xs={12} sm={6} md={4}>
                                                                <Select
                                                                    label="Sexo"
                                                                    options={[
                                                                        { label: '-- Selecione --', value: 'unknown', id: 'unknown' },
                                                                        { label: 'Masculino', value: 'male', id: 'male' },
                                                                        { label: 'Feminino', value: 'female', id: 'female' },
                                                                    ]}
                                                                    textFieldProps={{
                                                                        name: 'sex',
                                                                        onChange: handleChange,
                                                                        fullWidth: true,
                                                                        value: values.sex,
                                                                    }}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} sm={6} md={4}>
                                                                <Input
                                                                    label="E-mail"
                                                                    textFieldProps={{
                                                                        name: 'email',
                                                                        placeholder: 'E-mail',
                                                                        onChange: handleChange,
                                                                        value: values.email,
                                                                        fullWidth: true,
                                                                        required: false,
                                                                    }}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} sm={6} md={4}>
                                                                <Input
                                                                    label="Telefone"
                                                                    inputComponent={PhoneMask}
                                                                    textFieldProps={{
                                                                        name: 'phone',
                                                                        placeholder: 'Telefone',
                                                                        onChange: handleChange,
                                                                        value: values.phone,
                                                                        fullWidth: true,
                                                                        required: false,
                                                                    }}
                                                                />
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                            <Grid container className={classes.formSection}>
                                                <Grid
                                                    container
                                                    style={{ marginBottom: '8px', marginTop: '8px' }}
                                                    justify='space-between'
                                                >
                                                    <Grid item style={{ textAlign: 'center' }}>
                                                        <Typography variant="subtitle1" className={classes.noMarginFormSectionTitle}>
                                                            PERÍODOS DE ACESSO
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item
                                                        style={{
                                                            display: 'flex',
                                                            marginLeft: '10px',
                                                        }}
                                                    >
                                                        <Grid container spacing={1} alignItems="center" justify="center">
                                                            <Typography>Acesso Regular</Typography>
                                                            <Switch
                                                                color="primary"
                                                                checked={fullAccess}
                                                                onChange={({ target }) => {
                                                                    setFullAccess(target.checked);
                                                                    scheduleRef.current.setFullAccess(target.checked);
                                                                }}
                                                                inputProps={{
                                                                    'aria-label': 'notification-status'
                                                                }}
                                                            />
                                                            <Typography>Acesso Total</Typography>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                                <Grid
                                                    item
                                                    xs={12}
                                                >
                                                    <SchedulePicker setMessage={setMessage} setSchedule={setSchedule} ref={scheduleRef} />
                                                </Grid>
                                            </Grid>

                                            <Grid container className={classes.formSection}>
                                                <Typography variant="subtitle1" className={classes.formSectionTitle}>
                                                    LOCAL DE ACESSO
                                                </Typography>
                                                <Grid item xs={12}>
                                                    <Grid item xs={12} sm={6} md={4}>
                                                        <Autocomplete
                                                            id="visiting_location"
                                                            options={places}
                                                            getOptionLabel={({ name }) => name || ''}
                                                            onChange={(_, value) => setSelectedPlace(value)}
                                                            getOptionSelected={(option, value) => (option.id === value.id)}
                                                            onInputChange={(_, value) => setPlacesSearch(value)}
                                                            value={selectedPlace}
                                                            required={true}
                                                            fullWidth
                                                        />
                                                    </Grid>
                                                </Grid>
                                            </Grid>

                                            {(values.role === 'employee') && (
                                                <Grid container className={classes.formSection}>
                                                    <Typography variant="subtitle1" className={classes.formSectionTitle}>
                                                        ORGANIZAÇÃO
                                                    </Typography>
                                                    <Grid container spacing={3}>
                                                        <Grid item xs={12} sm={6} md={3}>
                                                            <Input
                                                                label="Ocupação"
                                                                textFieldProps={{
                                                                    name: 'occupation',
                                                                    placeholder: 'Ocupação',
                                                                    onChange: handleChange,
                                                                    value: values.occupation,
                                                                    fullWidth: true,
                                                                    required: false,
                                                                }}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12} sm={6} md={3}>
                                                            <Autocomplete
                                                                label="Estrutura Organizacional"
                                                                placeholder="Estrutura Organizacional"
                                                                id="org_id"
                                                                options={orgsSelect}
                                                                getOptionLabel={({ name }) => name || ''}
                                                                onChange={(_, value) => setSelectedOrg(value)}
                                                                getOptionSelected={(option, value) => (option.id === value.id)}
                                                                onInputChange={(_, value) => setOrgSearch(value)}
                                                                value={selectedOrg}
                                                                required={true}
                                                                fullWidth />
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            )}
                                            <Grid container className={classes.formSection}>
                                                <Typography variant="subtitle1" className={classes.formSectionTitleTwo}>
                                                    INFORMAÇÕES PERSONALIZADAS
                                                </Typography>
                                                <Grid container spacing={3}>
                                                    {customInputs.map((input, index) => {
                                                        if (index === 0 && values.custom_inputs.length === 0) {
                                                            values.custom_inputs = customInputs
                                                        }

                                                        return (
                                                            <Grid key={index} item xs={12} sm={6} md={4}>
                                                                {
                                                                    input.type === "normal" ? (
                                                                        <Input
                                                                            label={input.name}
                                                                            textFieldProps={{
                                                                                id: `custom_inputs${index}.information`,
                                                                                name: `custom_inputs[${index}].information`,
                                                                                onChange: handleChange,
                                                                                value: values.custom_inputs[index].hasOwnProperty('information') ? values.custom_inputs[index]['information'] : '',
                                                                                fullWidth: true,
                                                                                required: input.is_required,
                                                                            }}

                                                                        />
                                                                    ) : (
                                                                        <Autocomplete
                                                                            label={input.name}
                                                                            id={`custom_inputs${index}.information`}
                                                                            options={input.options?.length && input.options.map((option) => ({ name: option, value: option, id: option }))}
                                                                            getOptionLabel={({ name }) => name || ''}
                                                                            onChange={(_, value) => setFieldValue(`custom_inputs[${index}].information`, value)}
                                                                            getOptionSelected={(option, value) => (option.id === value.id)}
                                                                            /* onInputChange={(_, value) => setPersonTypeSearch(value)} */
                                                                            value={values.custom_inputs[index].hasOwnProperty('information') ? values.custom_inputs[index]['information'] : ''}
                                                                            required={input.is_required}
                                                                            fullWidth
                                                                        />
                                                                    )
                                                                }
                                                            </Grid>
                                                        )
                                                    })}
                                                </Grid>
                                            </Grid>
                                            <Grid container className={classes.formSection}>
                                                <Typography variant="subtitle1" className={classes.formSectionTitle}>
                                                    OBSERVAÇÕES
                                                </Typography>
                                                <Grid item xs={12} style={{ height: '100%' }}>
                                                    <textarea
                                                        placeholder="Escreva o texto aqui"
                                                        multiline
                                                        minRows={20}
                                                        className={classes.notesField}
                                                        value={values.notes}
                                                        onChange={({ target }) => setFieldValue('notes', target.value)}
                                                    />
                                                </Grid>
                                            </Grid>
                                            {(values.role === 'employee') && (
                                                <Grid container className={classes.formSection}>
                                                    <Typography xs={12} variant="subtitle1" className={classes.formSectionTitle}>
                                                        PERMISSÕES
                                                    </Typography>
                                                    <Grid container spacing={3}>
                                                        <Grid item xs={12} sm={6} md={4} className={classes.loginField}>
                                                            <Typography component="label" className={classes.fieldLabel}>
                                                                Acesso ao sistema
                                                            </Typography>
                                                            <Paper
                                                                className={classes.loginContainer}
                                                                onClick={() => {
                                                                    if (enabledToLogin) {
                                                                        values.login = ''
                                                                        values.password = ''
                                                                    }
                                                                    setEnabledToLogin(!enabledToLogin)
                                                                }}
                                                                align='center'
                                                            >
                                                                <Checkbox
                                                                    name='enabledToLogin'
                                                                    checked={enabledToLogin}
                                                                    color="primary"
                                                                    size="small"
                                                                    placeholder='login'
                                                                />
                                                                <div className={classes.cameraName}>
                                                                    <Typography variant="subtitle2">
                                                                        Habilitar/Desabilitar Login
                                                                    </Typography>
                                                                </div>
                                                            </Paper>
                                                        </Grid>
                                                        <Grid item xs={12} sm={6} md={4}>
                                                            <Input
                                                                label="Login"
                                                                textFieldProps={{
                                                                    name: 'login',
                                                                    placeholder: 'Login do usuário',
                                                                    onChange: handleChange,
                                                                    value: values.login,
                                                                    fullWidth: true,
                                                                    disabled: !enabledToLogin,
                                                                    required: enabledToLogin,
                                                                }}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12} sm={6} md={4}>
                                                            <Input
                                                                label="Senha"
                                                                textFieldProps={{
                                                                    name: 'password',
                                                                    type: 'password',
                                                                    placeholder: 'Senha do usuário',
                                                                    onChange: handleChange,
                                                                    value: values.password,
                                                                    fullWidth: true,
                                                                    disabled: !enabledToLogin,
                                                                    required: enabledToLogin,
                                                                }}
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                    <Grid container spacing={3} style={{
                                                        marginTop: 2
                                                    }}>
                                                        <Grid item xs={12} sm={6} md={4}>
                                                            <Select
                                                                label="Cadastro Ativo"
                                                                options={[
                                                                    { label: "Não", value: false },
                                                                    { label: "Sim", value: true },
                                                                ]}
                                                                textFieldProps={{
                                                                    name: "active_register",
                                                                    value: values.active_register,
                                                                    onChange: handleChange,
                                                                    fullWidth: true,
                                                                }}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12} sm={6} md={4}>
                                                            <Select
                                                                label="Ignorar Passback"
                                                                tip={(
                                                                    <Typography>
                                                                        Ao ativar essa opção, as regras de passback não se aplicaram a essa pessoa.
                                                                        <br />
                                                                        <i>Usar com cautela.</i>
                                                                    </Typography>
                                                                )}
                                                                options={[
                                                                    { label: "Não", value: false },
                                                                    { label: "Sim", value: true },
                                                                ]}
                                                                textFieldProps={{
                                                                    name: "antipassback",
                                                                    value: values.antipassback,
                                                                    onChange: handleChange,
                                                                    fullWidth: true,
                                                                }}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12} sm={6} md={4}>
                                                            <Select
                                                                label="Apenas permitido por acesso do relacionado"
                                                                tip={(
                                                                    <Typography>
                                                                        Essa pessoa so poderá acessar se um dos seus vínculos de depêndencia realizou uma entrada nos últimos 5 minutos.
                                                                    </Typography>
                                                                )}
                                                                options={[
                                                                    { label: "Não", value: false },
                                                                    { label: "Sim", value: true },
                                                                ]}
                                                                textFieldProps={{
                                                                    name: "only_allowed_by_related_access",
                                                                    value: values.only_allowed_by_related_access,
                                                                    onChange: handleChange,
                                                                    fullWidth: true,
                                                                }}
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            )}
                                            <Grid item xs={12} className={classes.formSection}>
                                                <Grid container spacing={2} justify='space-evenly'>
                                                    <Grid item xs={12} sm={6} md={4}>
                                                        <CredentialsManager
                                                            ref={credentialsRef}
                                                            setMessage={setMessage}
                                                            userName={values.name}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} sm={6} md={4}>
                                                        <Button
                                                            variant="outlined"
                                                            onClick={toggleProfilesModal}
                                                            fullWidth={true}
                                                            className={classes.button}
                                                        >
                                                            GERENCIAR PERFIS
                                                        </Button>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                            <Grid item xs={12} className={classes.formSection}>
                                                <Grid container spacing={2} justify='space-evenly'>
                                                    <Grid item xs={12} sm={6} md={4}>
                                                        <Button
                                                            variant="outlined"
                                                            onClick={() => setOpenRelatedModal(true)}
                                                            fullWidth={true}
                                                            className={classes.button}
                                                        >
                                                            Vínculos de relacionamento {`(${relatedRelationships.length})`}
                                                        </Button>
                                                    </Grid>
                                                    <Grid item xs={12} sm={6} md={4}>
                                                        <Button
                                                            variant="outlined"
                                                            fullWidth={true}
                                                            onClick={() => setOpenDependantModal(true)}
                                                            className={classes.button}
                                                        >
                                                            Vínculos de dependência {`(${dependantRelationships.length})`}
                                                        </Button>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                            <Grid item xs={12} className={classes.formSection}>
                                                <Typography variant="subtitle1" className={classes.formSectionTitle}>
                                                    AUTORIZAÇÃO
                                                </Typography>
                                                <AccessPicker ref={accessRef} />
                                            </Grid>
                                            </div>
                                            <div className={classes.formActions}>
                                                <Button
                                                    disabled={isSubmitting}
                                                    type="submit"
                                                    variant="contained"
                                                    form="user-create"
                                                    color="primary"
                                                    endIcon={<SaveIcon />}
                                                    className={classes.saveButton}
                                                >
                                                    {isSubmitting ? 'Salvando...' : 'Salvar dados'}
                                                </Button>
                                            </div>
                                        </form>
                                    </Paper>
                                </Grid>
                                <FullScreenDialog
                                    open={openRTSP}
                                    title={`${selectedWebcam?.name} - ${loadingRSTP ? 'CARREGANDO' : (rtspRunning ? 'CONECTADO' : 'DESCONECTADO')}`}
                                    onClose={handleCloseRSTP}
                                >
                                    <Grid
                                        xs={12}
                                        style={{display: 'flex', marginBottom: 20}}
                                        justify="center"
                                        alignItems="center"
                                    >
                                        <canvas ref={rtspCanvas} style={{ height: '100%', width: '60%', borderRadius: '8px', objectFit: 'contain' }}></canvas>
                                    </Grid>
                                    {(!loadingRSTP && rtspRunning) && (
                                        <Grid item xs={12} style={{textAlign: 'center'}}>
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                onClick={async () => takeWebcamSnapshot(setFieldValue)}
                                                endIcon={<PhotoCameraIcon />}
                                            >
                                                Tirar foto
                                            </Button>
                                        </Grid>
                                    )}
                                </FullScreenDialog>
                            </>
                        )}
                    </Formik>
                </Grid>
                {!!message.open && (
                    <Alert
                        open={message.open}
                        autoHideDuration={6000}
                        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                        severity={message.variant}
                        onClose={closeMessage}
                    >
                        {message.text}
                    </Alert>
                )}
            </main>
            <IPWebcamPicker
                open={webcamPickerOpen}
                onSelect={webcam => setSelectedWebcam(webcam)}
                onClose={() => setWebcamPickerOpen(false)}
            />
            <Popup
                openPopup={openRelatedModal}
                setOpenPopup={setOpenRelatedModal}
                title="Adicione pessoas relacionadas a essa pessoa"
            >
                <Grid container spacing={3}>
                    <Grid item xs={12} className={classes.modalToolbar}>
                        <Grid item xs={12} sm={6} md={4}>
                            <Input
                                icon={<SearchIcon style={{ color: grey[400] }} />}
                                iconPosition="start"
                                textFieldProps={{
                                    placeholder: 'Buscar…',
                                    onChange: ({ target }) => setRelatedSearch(target.value),
                                    values: relatedSearch,
                                    fullWidth: true
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                            <FormControlLabel
                                label="Mostrar apenas selecionados"
                                style={{
                                    userSelect: "none",
                                }}
                                checked={fetchOnlySelectedRelated}
                                onChange={({ target: { checked } }) => handleOnlySelectedRelated(checked)}
                                control={
                                    <Checkbox
                                        color='primary'

                                    />
                                }
                            />
                        </Grid>
                    </Grid>
                    <Grid item xs={12}>
                        <TableContainer component={Paper}>
                            <Table className={classes.table} size="small" aria-label="users list">
                                <TableHead>
                                    <TableRow>
                                        <TableCell className={classes.tableHead}>ID</TableCell>
                                        <TableCell className={classes.tableHead}>Nome</TableCell>
                                        <TableCell className={classes.tableHead}>Tipo de Documento</TableCell>
                                        <TableCell className={classes.tableHead}>Nº do Documento</TableCell>
                                        <TableCell className={classes.tableHead}>Tipo de Pessoa</TableCell>
                                        <TableCell className={classes.tableHead}>
                                            <Checkbox
                                                name="addAllUsers"
                                                color="primary"
                                                // checked={selectedUsers.length === users.length}
                                                checked={relatedResult.every(el => {
                                                    return relatedRelationships.includes(el.id);
                                                })}
                                                onChange={({ target }) => checkRelated('all', target.checked)}
                                            />
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {!!relatedResult && relatedResult.map(person => (
                                        <TableRow key={person.id}>
                                            <TableCell className={classes.tableBody} component="th" scope="row">
                                                {person.id}
                                            </TableCell>
                                            <TableCell className={classes.tableBody}>
                                                <RedirectToUser pType={person.person_type_id} uId={person.id}>
                                                    {person.name}
                                                </RedirectToUser>
                                            </TableCell>
                                            <TableCell className={classes.tableBody}>
                                                {person.doc_type && person?.doc_type === 'ic' ? 'RG' :
                                                    person?.doc_type === 'passport' ? 'Passaporte' :
                                                        person?.doc_type === 'other' ? 'Outro' :
                                                            person?.doc_type === 'unknown' ? 'CPF' :
                                                                'Não identificado'}
                                            </TableCell>
                                            <TableCell className={classes.tableBody}>
                                                {person.doc_number ? person.doc_number : "Não identificado"}
                                            </TableCell>
                                            <TableCell className={classes.tableBody}>
                                                {person.PersonType?.name ? person.PersonType?.name : "Não identificado"}
                                            </TableCell>
                                            <TableCell className={classes.tableBody}>
                                                <Checkbox
                                                    name="addUser"
                                                    color="primary"
                                                    checked={relatedRelationships.includes(person.id)}
                                                    onChange={({ target }) => checkRelated('single', target.checked, person.id)}
                                                />
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <TablePagination
                            rowsPerPageOptions={[10, 20, 30]}
                            component="div"
                            count={relatedTotal}
                            rowsPerPage={relatedLimit}
                            page={relatedPage}
                            labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
                            labelRowsPerPage="Registros por página"
                            onChangePage={(_, newPage) => changePage(_, newPage, 'related')}
                            onChangeRowsPerPage={({ target }) => quantityPerPage(target, 'related')}
                        />
                    </Grid>
                </Grid>
            </Popup>
            <Popup
                openPopup={openDependantModal}
                setOpenPopup={setOpenDependantModal}
                title="Adicione pessoas das quais a atual depende"
            >
                <Grid container spacing={3}>
                    <Grid item xs={12} className={classes.modalToolbar}>
                        <Grid item xs={12} sm={6} md={4}>
                            <Input
                                icon={<SearchIcon style={{ color: grey[400] }} />}
                                iconPosition="start"
                                textFieldProps={{
                                    placeholder: 'Buscar…',
                                    onChange: ({ target }) => setDependantSearch(target.value),
                                    values: dependantSearch,
                                    fullWidth: true,
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                            <FormControlLabel
                                label="Mostrar apenas selecionados"
                                style={{
                                    userSelect: "none",
                                }}
                                checked={fetchOnlySelectedDependant}
                                onChange={({ target: { checked } }) => handleOnlySelectedDependant(checked)}
                                control={
                                    <Checkbox
                                        color='primary'

                                    />
                                }
                            />
                        </Grid>
                    </Grid>
                    <Grid item xs={12}>
                        <TableContainer component={Paper}>
                            <Table className={classes.table} size="small" aria-label="users list">
                                <TableHead>
                                    <TableRow>
                                        <TableCell className={classes.tableHead}>ID</TableCell>
                                        <TableCell className={classes.tableHead}>Nome</TableCell>
                                        <TableCell className={classes.tableHead}>Tipo de Documento</TableCell>
                                        <TableCell className={classes.tableHead}>Nº do Documento</TableCell>
                                        <TableCell className={classes.tableHead}>Tipo de Pessoa</TableCell>
                                        <TableCell className={classes.tableHead}>
                                            <Checkbox
                                                name="addAllUsers"
                                                color="primary"
                                                // checked={selectedUsers.length === users.length}
                                                checked={dependantResult.every(el => {
                                                    return dependantRelationships.includes(el.id);
                                                })}
                                                onChange={({ target }) => checkDependant('all', target.checked)}
                                            />
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {!!dependantResult && dependantResult.map(person => (
                                        <TableRow key={person.id}>
                                            <TableCell className={classes.tableBody} component="th" scope="row">
                                                {person.id}
                                            </TableCell>
                                            <TableCell className={classes.tableBody}>
                                                <RedirectToUser pType={person.person_type_id} uId={person.id}>
                                                    {person.name}
                                                </RedirectToUser>
                                            </TableCell>
                                            <TableCell className={classes.tableBody}>
                                                {person.doc_type && person?.doc_type === 'ic' ? 'RG' :
                                                    person?.doc_type === 'passport' ? 'Passaporte' :
                                                        person?.doc_type === 'other' ? 'Outro' :
                                                            person?.doc_type === 'unknown' ? 'CPF' :
                                                                'Não identificado'}
                                            </TableCell>
                                            <TableCell className={classes.tableBody}>
                                                {person.doc_number ? person.doc_number : "Não identificado"}
                                            </TableCell>
                                            <TableCell className={classes.tableBody}>
                                                {person.PersonType?.name ? person.PersonType?.name : "Não identificado"}
                                            </TableCell>
                                            <TableCell className={classes.tableBody}>
                                                <Checkbox
                                                    name="addUser"
                                                    color="primary"
                                                    checked={dependantRelationships.includes(person.id)}
                                                    onChange={({ target }) => checkDependant('single', target.checked, person.id)}
                                                />
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <TablePagination
                            rowsPerPageOptions={[10, 20, 30]}
                            component="div"
                            count={dependantTotal}
                            rowsPerPage={dependantLimit}
                            page={dependantPage}
                            labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
                            labelRowsPerPage="Registros por página"
                            onChangePage={(_, newPage) => changePage(_, newPage, 'dependant')}
                            onChangeRowsPerPage={({ target }) => quantityPerPage(target, 'dependant')}
                        />
                    </Grid>
                </Grid>
            </Popup>
            <Popup
                openPopup={openProfilesModal}
                setOpenPopup={setOpenProfilesModal}
                title="Perfis"
            >
                <Grid container spacing={3}>
                    <Grid item xs={12} className={classes.modalToolbar}>
                        <Grid item xs={12} sm={6} md={4}>
                            <Input
                                icon={<SearchIcon style={{ color: grey[400] }} />}
                                iconPosition="start"
                                textFieldProps={{
                                    placeholder: 'Buscar…',
                                    onChange: ({ target }) => setProfilesSearch(target.value),
                                    values: profilesSearch,
                                    fullWidth: true
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                            <FormControlLabel
                                label="Mostrar apenas selecionados"
                                style={{
                                    userSelect: "none",
                                }}
                                checked={fetchOnlySelectedProfiles}
                                onChange={({ target: { checked } }) => handleOnlySelectedProfiles(checked)}
                                control={
                                    <Checkbox
                                        color='primary'
                                    />
                                }
                            />
                        </Grid>
                    </Grid>
                    <Grid item xs={12}>
                        <TableContainer component={Paper}>
                            <Table className={classes.table} size="small" aria-label="profiles list">
                                <TableHead>
                                    <TableRow>
                                        <TableCell className={classes.tableHead}>ID</TableCell>
                                        <TableCell className={classes.tableHead}>Nome</TableCell>
                                        <TableCell className={classes.tableHead}>
                                            <Checkbox
                                                name="addAllProfiles"
                                                color="primary"
                                                checked={profiles.every(el => {
                                                    return selectedProfiles.includes(el.id);
                                                })}
                                                onChange={({ target }) => checkProfile('all', target.checked)}
                                            />
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {!!profiles && profiles.map(profile => (
                                        <TableRow key={profile.id}>
                                            <TableCell className={classes.tableBody} component="th" scope="row">
                                                {profile.id}
                                            </TableCell>
                                            <TableCell className={classes.tableBody}>
                                                {profile.name}
                                            </TableCell>
                                            <TableCell className={classes.tableBody}>
                                                <Checkbox
                                                    name="addProfile"
                                                    color="primary"
                                                    checked={selectedProfiles.includes(profile.id)}
                                                    onChange={({ target }) => checkProfile('single', target.checked, profile.id)}
                                                />
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <TablePagination
                            rowsPerPageOptions={[10, 20, 30]}
                            component="div"
                            count={profilesTotal}
                            rowsPerPage={profilesLimit}
                            page={profilesPage}
                            labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
                            labelRowsPerPage="Registros por página"
                            onChangePage={(_, newPage) => changePage(_, newPage, 'profile')}
                            onChangeRowsPerPage={({ target }) => quantityPerPage(target, 'profile')}
                        />
                    </Grid>
                </Grid>
            </Popup>
            <Popup
                openPopup={openGoBack}
                setOpenPopup={setOpenGoBack}
                title="Voltar a listagem de pessoas?"
                width="30%"
            >
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: 6,
                    }}
                >
                    <Button
                        variant="contained"
                        color="primary"
                        style={{ width: "40%", fontWeight: 700 }}
                        size="large"
                        onClick={() => history.push("/pessoa")}
                    >
                        SIM
                    </Button>
                    <Button
                        variant="contained"
                        color="secondary"
                        style={{ width: "40%", fontWeight: 700 }}
                        size="large"
                        onClick={() => setOpenGoBack(false)}
                    >
                        NÃO
                    </Button>
                </div>
            </Popup>
        </div >
    );
}

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        minHeight: '100vh',
    },
    content: {
        flexGrow: 1,
        minWidth: 0,
        padding: theme.spacing(3),
        marginTop: theme.spacing(5),
        marginBottom: theme.spacing(6),
        [theme.breakpoints.down('xs')]: {
            padding: theme.spacing(2),
        },
    },
    pageGrid: {
        marginLeft: 'auto',
        marginRight: 'auto',
        maxWidth: 1440,
    },
    pageHeader: {
        alignItems: 'center',
        display: 'flex',
        gap: theme.spacing(2),
        justifyContent: 'space-between',
        [theme.breakpoints.down('xs')]: {
            alignItems: 'flex-start',
            flexDirection: 'column',
        },
    },
    pageSubtitle: {
        color: '#64748b',
        fontSize: '.82rem',
        lineHeight: 1.5,
        marginLeft: 64,
        marginTop: theme.spacing(.5),
        [theme.breakpoints.down('xs')]: {
            marginLeft: 0,
        },
    },
    helpLink: {
        alignItems: 'center',
        backgroundColor: '#fff',
        border: '1px solid #dbe3ec',
        borderRadius: 10,
        color: '#475569',
        display: 'inline-flex',
        flexShrink: 0,
        fontSize: '.82rem',
        fontWeight: 600,
        gap: theme.spacing(.75),
        minHeight: 40,
        padding: theme.spacing(0, 1.5),
        textDecoration: 'none',
        transition: 'all .2s ease',
        '& svg': {
            color: '#1976d2',
            fontSize: 20,
        },
        '&:hover': {
            backgroundColor: '#f8fafc',
            borderColor: '#93c5fd',
        },
    },
    paper: {
        backgroundColor: '#f8fafc',
        border: '1px solid #e5e7eb',
        borderRadius: 16,
        boxShadow: '0 10px 30px rgba(15, 23, 42, .05)',
        overflow: 'hidden',
    },
    form: {
        display: 'flex',
        flexDirection: 'column',
    },
    formHeader: {
        backgroundColor: '#fff',
        borderBottom: '1px solid #e5e7eb',
        padding: theme.spacing(2.5, 3),
        [theme.breakpoints.down('xs')]: {
            padding: theme.spacing(2),
        },
    },
    formHeaderTitle: {
        color: '#1e293b',
        fontSize: '1rem',
        fontWeight: 700,
    },
    formHeaderSubtitle: {
        color: '#64748b',
        fontSize: '.78rem',
        lineHeight: 1.45,
        marginTop: 2,
    },
    formBody: {
        padding: theme.spacing(3),
        [theme.breakpoints.down('xs')]: {
            padding: theme.spacing(2),
        },
    },
    photoSection: {
        marginBottom: theme.spacing(1),
    },
    formSection: {
        backgroundColor: '#fff',
        border: '1px solid #e2e8f0',
        borderRadius: 14,
        marginBottom: theme.spacing(2.5),
        padding: theme.spacing(2.25),
        '& > .MuiGrid-container:not(:last-child)': {
            marginBottom: theme.spacing(.25),
        },
        [theme.breakpoints.down('xs')]: {
            padding: theme.spacing(1.75),
        },
    },
    formSectionTitle: {
        color: '#334155',
        fontSize: '.78rem',
        fontWeight: 800,
        letterSpacing: '.055em',
        marginBottom: theme.spacing(1.75),
        width: '100%',
    },
    formSectionTitleTwo: {
        color: '#334155',
        fontSize: '.78rem',
        fontWeight: 800,
        letterSpacing: '.055em',
        marginBottom: theme.spacing(1.75),
        width: '100%',
    },
    userRoles: {
        '& > button': {
            marginRight: theme.spacing(1),
        },
    },
    faceImageContainer: {
        width: '100%',
        height: '303px',
        backgroundColor: '#fff',
        border: '1px solid #dbe3ec',
        borderRadius: 14,
        boxShadow: '0 6px 18px rgba(15, 23, 42, .06)',
        display: 'flex',
        alignItems: 'flex-end',
        flexDirection: 'column',
        overflow: 'hidden',
    },
    faceImageContent: {
        width: '100%',
        flex: 7,
        background: 'linear-gradient(145deg, #f8fafc 0%, #eef4fb 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: theme.spacing(1),
        '& img, & video': {
            borderRadius: 9,
            objectFit: 'contain',
        },
    },
    faceImageButton: {
        borderBottom: 0,
        borderLeft: 0,
        borderRadius: 0,
        borderRight: 0,
        flex: 1,
        fontWeight: 600,
        minHeight: 40,
        textTransform: 'none',
    },
    faceImageButtonDefault: {
        borderBottom: 0,
        borderLeft: 0,
        borderRadius: 0,
        borderRight: 0,
        flex: 1,
        fontWeight: 600,
        minHeight: 40,
        textTransform: 'none',
    },
    removeImageButton: {
        borderBottom: 0,
        borderLeft: 0,
        borderRadius: 0,
        borderRight: 0,
        fontWeight: 600,
        minHeight: 40,
        textTransform: 'none',
    },
    noImage: {
        textAlign: 'center',
        color: '#94a3b8',
        '& svg': {
            fontSize: 42,
            marginBottom: theme.spacing(.5),
        },
        '& h6': {
            fontSize: '.72rem',
            fontWeight: 700,
            letterSpacing: '.08em',
        },
    },
    cameraContainer: {
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
        '& h6 > span': {
            marginLeft: theme.spacing(.5),
        },
        '&:hover': {
            boxShadow: '0 2px 10px 1px rgba(150,150,150,.3)',
        },
    },
    daysPicker: {
        background: '#F0F0F0',
        justifyContent: 'space-evenly',
        alignItems: 'center',
    },
    dayButton: {
        padding: '10%',
    },
    loginContainer: {
        alignItems: 'center',
        background: '#f8fafc',
        border: '1px solid #dbe3ec',
        borderRadius: 10,
        boxSizing: 'border-box',
        boxShadow: 'none',
        color: '#475569',
        cursor: 'pointer',
        display: 'flex',
        minHeight: 37,
        paddingRight: theme.spacing(1),
        transition: 'all .2s ease',
        width: '100%',
        '& h6': {
            fontSize: '.82rem',
            lineHeight: 1.25,
        },
        '&:hover': {
            backgroundColor: '#eff6ff',
            borderColor: '#93c5fd',
        },
    },
    loginField: {
        display: 'flex',
        flexDirection: 'column',
    },
    fieldLabel: {
        color: grey[500],
        display: 'block',
        fontSize: '.875rem',
        fontWeight: 'bold',
        marginBottom: theme.spacing(1),
    },
    enableAll: {
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
        background: 'transparent',
        boxShadow: 'none',
        fontWeight: 'bold',
        color: '#9e9e9e',
        boxSizing: 'border-box',

    },
    customInput: {
        color: '#9e9e9e',
        fontWeight: 'bold',
        marginBottom: '8px',
        background: 'transparent',

    },
    leftSide: {
        width: '39%',
        boxShadow: '0 6px 8px #cdcdcd',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        padding: theme.spacing(1),
        '& h6': {
            fontWeight: 'bold',
            color: '#616161',
        },
    },
    rightSide: {
        padding: theme.spacing(2),
        width: '60%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        '& h5': {
            fontWeight: 'bold',
            color: '#616161',
        },
    },
    button: {
        backgroundColor: '#fff',
        borderColor: '#cbd5e1',
        borderRadius: 9,
        boxShadow: '0 4px 12px rgba(15, 23, 42, .05)',
        color: '#334155',
        fontWeight: 700,
        minHeight: 44,
        textTransform: 'none',
        '&:hover': {
            backgroundColor: '#f8fafc',
            borderColor: '#93c5fd',
        },
    },
    saveButton: {
        borderRadius: 9,
        boxShadow: '0 6px 14px rgba(25, 118, 210, .2)',
        fontWeight: 700,
        minHeight: 44,
        minWidth: 180,
        textTransform: 'none',
        [theme.breakpoints.down('xs')]: {
            width: '100%',
        },
    },
    formActions: {
        alignItems: 'center',
        backgroundColor: '#fff',
        borderTop: '1px solid #e5e7eb',
        display: 'flex',
        justifyContent: 'flex-end',
        padding: theme.spacing(2, 3),
        [theme.breakpoints.down('xs')]: {
            padding: theme.spacing(1.5, 2),
        },
    },
    notesField: {
        backgroundColor: '#fff',
        border: '1px solid #cbd5e1',
        borderRadius: 10,
        boxSizing: 'border-box',
        color: '#475569',
        fontFamily: 'inherit',
        fontSize: '.9rem',
        lineHeight: 1.5,
        minHeight: 150,
        outline: 'none',
        padding: theme.spacing(1.5),
        resize: 'vertical',
        transition: 'border-color .2s ease, box-shadow .2s ease',
        width: '100%',
        '&:focus': {
            borderColor: '#1976d2',
            boxShadow: '0 0 0 3px rgba(25, 118, 210, .12)',
        },
    },
    modalToolbar: {
        alignItems: 'center',
        display: 'flex',
        flexWrap: 'wrap',
        gap: theme.spacing(2),
        '& > .MuiGrid-item': {
            padding: 0,
        },
        [theme.breakpoints.down('xs')]: {
            alignItems: 'stretch',
            flexDirection: 'column',
            '& > .MuiGrid-item': {
                maxWidth: '100%',
                width: '100%',
            },
        },
    },
    marginTop: {
        marginTop: '12px',
    },
    fingerprintImage: {
        height: '100px',
        width: '100px'
    },
    statusLabel: {
        display: 'block',
        fontWeight: 'bold',
        color: grey[500],
        marginBottom: theme.spacing(1),
    },
    noMarginFormSectionTitle: {
        color: '#334155',
        fontSize: '.78rem',
        fontWeight: 800,
        letterSpacing: '.055em',
    },
    tableContainer: {
        maxHeight: '95%',
        width: '100%',
    },
    table: {
        width: '100%',
    },
    tableHead: {
        backgroundColor: '#f8fafc',
        borderBottom: '1px solid #e2e8f0',
        color: '#64748b',
        fontSize: '.72rem',
        fontWeight: 700,
        textAlign: 'center',
        textTransform: 'uppercase',
    },
    tableBody: {
        color: '#334155',
        textAlign: 'center',
    },
}));

const PhoneMask = props => {
    const { inputRef, ...other } = props;

    return (
        <MaskedInput
            {...other}
            ref={ref => inputRef(ref ? ref.inputElement : null)}
            mask={['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
            placeholderChar={'_'}
            showMask
        />
    );
};
